import AreaTypes from "types/AreaTypes";
import ConfigMapAreaType from "types/ConfigMapAreaType";

class AreasUtils {
  static sortAreasByConfigMapAreasOrder(
    areas: AreaTypes[],
    configMapAreas: ConfigMapAreaType[]
  ): void {
    if (!areas || !configMapAreas) return;

    areas.sort((a, b) => {
      const indexA = configMapAreas.findIndex((area) => area.area_id === a.id);
      const indexB = configMapAreas.findIndex((area) => area.area_id === b.id);

      if (areas.length === configMapAreas.length) {
        return indexB - indexA;
      }

      /* If both array doesn't have the same length, 
      put every unmatched element at the end of the array. */
      return indexA - indexB || configMapAreas.length;
    });
  }
}

export default AreasUtils;
